import React from "react"

import { FiMoreVertical, FiMenu } from "react-icons/fi"

import Link from "~components/Link"

import INTERNATIONAL_SITES from "~models/InternationalSites"
import * as style from "./Sidebar.module.scss"

const Sidebar = ({
  microcopy, state, toggleSidebar, hideSidebar,
}) => (
  <>
    <button
      className={style.toggle}
      data-visible={state.visible}
      data-reactive={state.reactive}
      onClick={toggleSidebar}
      aria-label="Menu"
    >
      <FiMenu />
      <FiMoreVertical />
      <span>&nbsp;</span>
    </button>
    <div
      data-role="sidebar"
      className={style.sidebar}
      data-reactive={state.reactive}
      data-visible={state.visible}
    >
      <ul>
        <li className={style.button}>
          <Link
            to="https://account.box.com/signup/n/developer#ty9l3"
            microcopy={microcopy}
          >
            {microcopy.text("headers.primary.buttons.signup.text", "Sign Up")}
          </Link>
        </li>
      </ul>
      {process.env.GATSBY_FEATURE_PRODUCT_DROPDOWN === "true" && (
        <ul>
          <li className={style.link}>
            <header>{microcopy.text("headers.primary.links.overview.text")}</header>
          </li>
          <li className={style.link}>
            <Link
              to="/platform/"
              microcopy={microcopy}
              className={style.dropdownLink}
            >
              {microcopy.text("headers.primary.links.learn.text")}
            </Link>
          </li>
          <li className={style.link}>
            <Link
              to="/sign/"
              microcopy={microcopy}
              className={style.dropdownLink}
            >
              {microcopy.text("headers.primary.links.learn-sign.text")}
            </Link>
          </li>
          <li className={style.link}>
            <Link
              to="/box-ui-elements/"
              microcopy={microcopy}
              className={style.dropdownLink}
            >
              {microcopy.text("headers.primary.links.buie.text")}
            </Link>
          </li>
          <li className={style.link}>
            <Link
              to="/ai-dev-zone/"
              microcopy={microcopy}
              className={style.dropdownLink}
            >
              {microcopy.text("headers.primary.links.ai_dev_zone.text")}
            </Link>
          </li>
        </ul>
      )}
      <ul>
        <li className={style.link}>
          <header>{microcopy.text("headers.secondary.dropdowns.docs")}</header>
        </li>
        {process.env.GATSBY_FEATURE_GUIDES === "true" && (
          <li className={style.link}>
            <Link to="/guides/" microcopy={microcopy} partiallyActive>
              {microcopy.text("headers.primary.links.guides.text")}
            </Link>
          </li>
        )}
        {process.env.GATSBY_FEATURE_REFERENCE === "true" && (
          <li className={style.link}>
            <Link to="/reference/" microcopy={microcopy} partiallyActive>
              {microcopy.text("headers.primary.links.api_reference.text")}
            </Link>
          </li>
        )}
      </ul>
      <ul>
        <li className={style.link}>
          <header>
            {microcopy.text("headers.secondary.dropdowns.additional_resources")}
          </header>
        </li>
        {process.env.GATSBY_FEATURE_SAMPLE_CODE_CATALOG === "true" && (
          <li className={style.link}>
            <Link to="/sample-code/" microcopy={microcopy} partiallyActive>
              {microcopy.text("headers.primary.links.sample_code.text")}
            </Link>
          </li>
        )}
        {process.env.GATSBY_FEATURE_PAGES === "true" && (
          <li className={style.link}>
            <Link to="/sdks-and-tools/" microcopy={microcopy} partiallyActive>
              {microcopy.text("headers.primary.links.sdks_and_tools.text")}
            </Link>
          </li>
        )}
        {process.env.GATSBY_FEATURE_CHANGELOG === "true" && (
          <li className={style.link}>
            <Link to="/changelog/" microcopy={microcopy} partiallyActive>
              {microcopy.text("changelog.title")}
            </Link>
          </li>
        )}
        <li className={style.link}>
          <Link
            to={microcopy.text("headers.primary.links.blog.url")}
            microcopy={microcopy}
            className={style.dropdownLink}
          >
            {microcopy.text("headers.primary.links.blog.text")}
          </Link>
        </li>
      </ul>
      {process.env.GATSBY_FEATURE_COMMUNITY === "true" && (
        <ul>
          <li className={style.link}>
            <header>
              {microcopy.text("headers.primary.links.connect.text")}
            </header>
          </li>
          <li className={style.link}>
            <Link
              to="https://community.box.com/"
              microcopy={microcopy}
              className={style.dropdownLink}
            >
              {microcopy.text("headers.primary.links.community_forum.text")}
            </Link>
          </li>
          <li className={style.link}>
            <Link
              to="/support/"
              microcopy={microcopy}
              className={style.dropdownLink}
            >
              {microcopy.text("headers.primary.links.support.text")}
            </Link>
          </li>
          <li className={style.link}>
            <Link
              to="https://community.box.com/events?tab=upcoming"
              microcopy={microcopy}
              className={style.dropdownLink}
            >
              {microcopy.text("headers.primary.links.events.text")}
            </Link>
          </li>
        </ul>
      )}
      <ul>
        <li className={style.link}>
          <header>
            {microcopy.text("footer.categories.international.title")}
          </header>
        </li>
        {INTERNATIONAL_SITES.map((site, index) => (
          <li key={index} className={style.link}>
            <a to={site.url} microcopy={microcopy} onClick={hideSidebar}>
              {site.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  </>
)

export default Sidebar
